module.exports = __webpack_public_path__ + "img/4_26@2x.8be22023.png";